import intl from "react-intl-universal";

import httpService from "../_utils/http-service";
import * as types from "./types";
import { signInSuccess } from "./_auth-action";
import { getHttpConfig } from "../_utils/auth-utils";
import { traceEvent } from "../_utils/analytics-utils";

export const checkEmailExists = (email, callback) => {
  return function(dispatch) {
    httpService
      .post(
        "/customers/validateRegister",
        {
          email
        },
        getHttpConfig()
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ existed: false });
        } else {
          callback({ existed: true });
        }
      })
      .catch(err => {
        callback({ existed: false });
      });
  };
};

export const setSocialSignup = signupData => {
  return function(dispatch) {
    dispatch({ type: types.SET_SOCIAL_SIGNUP, payload: signupData });
  };
};

export const socialSignin = (signInData, callback) => {
  
  return function(dispatch, getState) {
    httpService
      .post("/customers/socialLogin", signInData, getHttpConfig())
      .then(res => {
        if (res.data.statusCode === 200) {
          const profile = res.data.data;
          signInSuccess({ profile, dispatch, callback, state: getState() });
        } else {
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "socialSignin");
        callback({ success: false, message: intl.get("general.serverError") });
      });
  };
};

export const socialSignup = (signupData, callback) => {
  return function(dispatch, getState) {
    httpService
      .post("customers/socialRegister", signupData, getHttpConfig())
      .then(res => {
        if (res.data.statusCode !== 200) {
          if (res.data.message === "Phone number exists already.") {
            callback({
              sucess: false,
              message: intl.get("signup.phoneNumberExists")
            });
          } else {
            traceEvent("error", "socialSignup");
            callback({ sucess: false });
          }
        } else {
          const profile = res.data.data;
          signInSuccess({ profile, dispatch, callback, state: getState() });
        }
      })
      .catch(err => {
        traceEvent("error", "socialSignup");
        callback({ success: false, message: intl.get("general.serverError") });
      });
  };
};
